import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectLanguageComponent } from './select-language/select-language.component';
import { RouterModule } from '@angular/router';
import { TranslateAllModule } from './translate-all/translate-all.module';

@NgModule({
  declarations: [SelectLanguageComponent],
  imports: [
    CommonModule,
    RouterModule,
    TranslateAllModule
  ],
  exports: [SelectLanguageComponent, TranslateAllModule]
})
export class CoreModule { }
